import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-movie-2-line text-lg text-white"></i>
                </div>
                <span className="font-heading text-xl font-bold text-white">
                  {siteConfig.name}
                </span>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {siteConfig.tagline}
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors text-foreground-300 hover:text-white" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors text-foreground-300 hover:text-white" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 hover:bg-primary-500 transition-colors text-foreground-300 hover:text-white" aria-label="邮箱">
                  <i className="ri-mail-line text-sm"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-4">快速导航</h3>
              <nav className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
                <Link to="/category/dongzuo" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">动作片</Link>
                <Link to="/category/kehuan" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">科幻片</Link>
                <Link to="/category/xiju" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">喜剧片</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              </nav>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-4">影视分类</h3>
              <nav className="flex flex-col gap-2.5">
                <Link to="/category/dianshiju" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">电视剧</Link>
                <Link to="/category/donghua" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">动画片</Link>
                <Link to="/category/kongbu" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">恐怖片</Link>
                <Link to="/category/aiqing" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">爱情片</Link>
                <Link to="/category/jilupian" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">纪录片</Link>
              </nav>
            </div>

            <div>
              <h3 className="font-heading text-base font-semibold text-white mb-4">联系我们</h3>
              <div className="flex flex-col gap-2.5 text-sm text-foreground-400">
                <p>客服邮箱：service@nongminyingshi.com</p>
                <p>客服热线：400-888-6666</p>
                <p>微信公众号：农民影视官方</p>
                <p className="mt-2 text-foreground-500 text-xs">工作时间：周一至周五 9:00-18:00</p>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {currentYear} {siteConfig.name} 版权所有 | 本站所有资源均来自网络，仅供学习和交流使用
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap">用户协议</a>
              <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="hover:text-foreground-300 transition-colors whitespace-nowrap">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}